import React from 'react';
import { motion } from 'framer-motion';
import { getImagePath } from '../../utils/imagePath';  // Correct path from components/club to utils

const Leadership = () => {
  // Leadership Team - Board Members
  const leaders = [
    {
      name: 'Michael Ogbuanu',
      position: 'President',
      bio: 'Leading the club with vision and dedication to community excellence.',
      image: getImagePath('images/team/member-1.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Chinedu Onyia',
      position: 'Vice President',
      bio: 'Committed to supporting the president and ensuring smooth club operations.',
      image: getImagePath('images/team/member-2.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Linda Ogbu',
      position: 'Secretary',
      bio: 'Managing club records and communications with precision and care.',
      image: getImagePath('images/team/member-3.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Ifeoma Willie-Pepple',
      position: 'Treasurer',
      bio: 'Overseeing club finances with transparency and strategic planning.',
      image: getImagePath('images/team/member-8.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Chima Tasieobi',
      position: 'Sports Member',
      bio: 'Driving sports activities and promoting athletic excellence.',
      image: getImagePath('images/team/member-6.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Grace Ikufisile',
      position: 'Cultural Member',
      bio: 'Enriching club life through cultural events and activities.',
      image: getImagePath('images/team/member-4.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Buhari Bello',
      position: 'Technical Member',
      bio: 'Ensuring technical excellence and facility maintenance.',
      image: getImagePath('images/team/member-5.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Emiel Ten Velde',
      position: 'General Member (Expatriate)',
      bio: 'Bringing international perspective to club development.',
      image: getImagePath('images/team/member-7.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Osademe Azubike',
      position: 'Social Member',
      bio: 'Organizing social events and fostering community connections.',
      image: getImagePath('images/team/Img10.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  // Club Administrators
  const administrators = [
    {
      name: 'Richard Chukwu',
      position: 'Club Manager',
      bio: 'Managing day-to-day club operations and member services.',
      image: getImagePath('images/team/member-9.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Paul Ovuche',
      position: 'Club Administrator',
      bio: 'Ensuring efficient administrative processes and member support.',
      image: getImagePath('images/team/member-91.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  return (
    <div className="leadership-page">
      {/* Hero Section */}
      <section className="page-hero leadership-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-eyebrow">THE CLUB</span>
            <h1 className="hero-title">Leadership <span className="text-green">Team</span></h1>
            <p className="hero-subtitle">Meet the dedicated individuals guiding NLNG RA Club towards excellence</p>
          </motion.div>
        </div>
      </section>

      {/* Leadership Grid - Board Members */}
      <section className="leadership-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">RA Club Executive Committee (RCEC)</span>
            <h2 className="section-title">Our <span className="text-green">Leaders</span></h2>
            <p className="section-subtitle">Experienced professionals committed to serving our community</p>
          </div>

          <div className="leadership-grid">
            {leaders.map((leader, index) => (
              <motion.div 
                key={index}
                className="leader-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="leader-image">
                  <img src={leader.image} alt={leader.name} />
                  <div className="leader-social">
                    <a href={leader.social.linkedin}><i className="fab fa-linkedin-in"></i></a>
                    <a href={leader.social.twitter}><i className="fab fa-twitter"></i></a>
                  </div>
                </div>
                <div className="leader-info">
                  <h3>{leader.name}</h3>
                  <p className="leader-position">{leader.position}</p>
                  <p className="leader-bio">{leader.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Administrators Section */}
      <section className="administrators-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">CLUB ADMINISTRATORS</span>
            <h2 className="section-title">Meet Our <span className="text-green">Administrators</span></h2>
            <p className="section-subtitle">Dedicated professionals ensuring smooth club operations</p>
          </div>

          <div className="administrators-grid">
            {administrators.map((admin, index) => (
              <motion.div 
                key={index}
                className="leader-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="leader-image">
                  <img src={admin.image} alt={admin.name} />
                  <div className="leader-social">
                    <a href={admin.social.linkedin}><i className="fab fa-linkedin-in"></i></a>
                    <a href={admin.social.twitter}><i className="fab fa-twitter"></i></a>
                  </div>
                </div>
                <div className="leader-info">
                  <h3>{admin.name}</h3>
                  <p className="leader-position">{admin.position}</p>
                  <p className="leader-bio">{admin.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leadership;